module.exports = __webpack_public_path__ + "static/media/leading-mental-health-large.5084c099.png";